import { getPhone } from './getPhone';
import { IPhoneNumber } from '../redux/reducers';

export const getFirstOrSecondPhone = (phones: Array<IPhoneNumber | null>) => {
  const hasSecondNumber = phones.length > 1 && phones[1] !== null;

  if (hasSecondNumber) {
    return getPhone(phones[1]);
  }

  return getPhone(phones[0]);
};
